module.exports = __webpack_public_path__ + "img/banner02.054e3020.jpg";